/**
 * ScrollToTop — scrolls the window to the top on every route change so navigating
 * between pages (especially the multi-step booking flow) always starts at the top
 * instead of retaining the previous page's scroll position.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
